/**
 * 预告管理列表页面权限
 */
export const APPLY_ANNOUNCEMENT_LIST_PAGE_UUID =
  '92412b57-8a2f-4595-ac40-bcd93c8e3be0'

/**
 * 预告管理权限
 */
export const APPLY_ANNOUNCEMENT_LIST_ACTION_UUID =
  '43d4e574-23e6-4533-911d-a0a5224cab20'

/**
 * 频道管理权限
 */
export const APPLY_ANNOUNCEMENT_CHANNEL_ACTION_UUID =
  '6c065e45-30b6-40dc-b1c6-1b0a29a9ff41'
